export const ERROR_BANNER_CSS = /* css */ `
  /* ── Error banner ── */
  .lk-widget-error {
    margin: 0 10px 8px; padding: 8px 12px; border-radius: 8px;
    background: rgba(211, 47, 47, 0.08); color: var(--wg-danger);
    font-size: 13px; line-height: 1.4;
    display: flex; align-items: center; gap: 8px;
  }
  .lk-widget-error > span { flex: 1; }
  .lk-widget-error-retry {
    flex-shrink: 0;
    background: var(--wg-danger); color: white; border: none; border-radius: 6px;
    padding: 4px 10px; font-size: 12px; font-weight: 600; cursor: pointer;
    transition: opacity 0.15s ease;
  }
  .lk-widget-error-retry:hover { opacity: 0.85; }
`;

export const RECONNECT_STATUS_CSS = /* css */ `
  /* ── Reconnecting status (agent dropped, rejoining) ── */
  .lk-widget-reconnect {
    margin: 0 10px 8px; padding: 6px 12px;
    color: var(--wg-fg-muted); font-size: 12.5px; line-height: 1.4;
    display: flex; align-items: center; justify-content: center; gap: 8px;
  }
  .lk-widget-reconnect-dot {
    width: 7px; height: 7px; border-radius: 50%; background: var(--wg-send-active);
    animation: lk-widget-reconnect-pulse 1.2s ease-in-out infinite;
  }
  @keyframes lk-widget-reconnect-pulse {
    0%, 100% { opacity: 0.25; transform: scale(0.85); }
    50% { opacity: 1; transform: scale(1); }
  }
  @media (prefers-reduced-motion: reduce) {
    .lk-widget-reconnect-dot { animation: none; opacity: 0.7; }
  }
`;
